export { PLUGIN_KEY, PLUGIN_PRIORITY, AutoColumnSize } from "./autoColumnSize.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/autoColumnSize/index.mjs
// module id = 1230
// module chunks = 1